import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Check, Sparkles } from "lucide-react";
import { DuoClairLogo } from "@/components/DuoClairLogo";
import { SiteMenu } from "@/components/SiteMenu";

export default function ConfirmationPage() {
  const { state } = useLocation();
  const businessName = state?.businessName;
  const hasToken = !!sessionStorage.getItem("dc_listino_token");

  return (
    <div className="min-h-screen flex flex-col" data-testid="confirmation-page">
      <header className="relative px-5 sm:px-8 h-20 flex items-center justify-center border-b border-white/5">
        <DuoClairLogo />
        <div className="absolute right-4 sm:right-8">
          <SiteMenu />
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="max-w-xl w-full text-center">
          <motion.div
            initial={{ scale: 0, rotate: -30 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.2 }}
            className="relative mx-auto w-24 h-24 mb-9"
          >
            <span className="absolute inset-0 rounded-full bg-gold/20 blur-2xl animate-pulse-gold" />
            <span className="relative w-full h-full rounded-full border border-gold/50 bg-coal flex items-center justify-center shadow-[0_0_60px_-10px_rgba(212,160,60,0.6)]">
              <Check className="w-10 h-10 text-gold" strokeWidth={2.5} />
            </span>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.45 }}>
            {businessName && <p className="eyebrow mb-4">Grazie, {businessName}</p>}
            <h1 className="font-display uppercase text-3xl sm:text-4xl tracking-wide leading-tight mb-5" data-testid="confirmation-title">
              <span className="chrome-text">La tua richiesta</span>{" "}
              <span className="gold-text">è stata ricevuta!</span>
            </h1>
            <p className="text-zinc-400 leading-relaxed mb-10 max-w-md mx-auto">
              Grazie per aver richiesto l'analisi gratuita DuoClair. Nel frattempo puoi esplorare le
              nostre offerte e configurare il servizio più adatto alla tua attività.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.65 }}
            className="flex flex-col items-center gap-4"
          >
            {hasToken && (
              <Link
                to="/listino"
                data-testid="confirmation-listino-button"
                className="btn-champagne inline-flex items-center gap-2.5 rounded-full px-9 py-4 font-bold text-sm sm:text-base tracking-tight hover:scale-[1.03] active:scale-[0.98] transition-transform duration-300"
              >
                <Sparkles className="w-4 h-4" /> Scopri il listino riservato
              </Link>
            )}
            <Link
              to="/"
              data-testid="confirmation-home-button"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 px-7 py-3.5 text-sm text-slate-200 hover:border-gold/40 hover:text-gold-light transition-all duration-300"
            >
              <ArrowLeft className="w-4 h-4" /> Torna alla home
            </Link>
            <Link to="/privacy" data-testid="confirmation-privacy-link" className="text-xs text-zinc-600 hover:text-gold-light transition-colors underline underline-offset-4 mt-2">
              Informativa privacy
            </Link>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
